export default "__VITE_ASSET__Bmh9OBEB__"